/* homearo: gentle scroll-reveal. Never hides content if JS fails, and is skipped in the theme editor. */
(function () {
  var root = document.documentElement;
  if (root.classList.contains('shopify-design-mode')) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sel = '.ha-head, .ha-trust > div, .ha-cats a, .ha-tile, .ha-split__body, .ha-why__card, .ha-review, .ha-news__in, .ha-policies > div, .ha-values > div';

  function init() {
    var els = document.querySelectorAll(sel);
    if (!els.length) return;
    root.classList.add('ha-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      el.classList.add('ha-reveal');
      el.style.setProperty('--ha-d', (i % 4) * 70 + 'ms');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
